import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const MoveLeft3 = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.666668 8H10.6667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M4 11.3333L0.666668 8L4 4.66667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 14H15.3333V2H12.6667V14Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>,
  'MoveLeft3'
);
